module.exports = [
    'as'
  , 'because'
  , 'for'
  , 'and'
  , 'nor'
  , 'but'
  , 'or'
  , 'yet'
  , 'so'
]
